import React, { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { AdminPeopleSoftFiles } from "./AdminPeopleSoftFiles";
import { AdminPeopleSoftUpload } from "./AdminPeopleSoftUpload";

export const AdminPeopleSoft = (props) => {
	const [subTab, setSubTab] = useState("files");

	return (
		<Tab.Container activeKey={subTab} onSelect={(k) => setSubTab(k)}>
			<Nav variant="tabs" style={{ marginBottom: "10px" }}>
				<Nav.Item>
					<Nav.Link eventKey="files">Files</Nav.Link>
				</Nav.Item>
				<Nav.Item>
					<Nav.Link eventKey="upload">Upload</Nav.Link>
				</Nav.Item>
			</Nav>
			<Tab.Content>
				<Tab.Pane eventKey="files">
					{subTab === "files" ? <AdminPeopleSoftFiles onChildUpdate={props.onChildUpdate} /> : <></>}
				</Tab.Pane>
				<Tab.Pane eventKey="upload">
					{subTab === "upload" ? <AdminPeopleSoftUpload onChildUpdate={props.onChildUpdate} onViewFiles={() => setSubTab("files")} /> : <></>}
				</Tab.Pane>
			</Tab.Content>
		</Tab.Container>
	);
};
